import { defineRouteDef, z } from '@/domains/common/api';

const llmLogEventSchema = z.object({
  ts: z.number(),
  task: z.string(),
  task_label: z.string(),
  model: z.string(),
  input_tokens: z.number(),
  output_tokens: z.number(),
  cache_read_tokens: z.number(),
  cache_creation_tokens: z.number(),
  cost_usd: z.number(),
});

export const llmLogStreamEvent = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('snapshot'), entries: z.array(llmLogEventSchema) }),
  z.object({ kind: z.literal('event'), entry: llmLogEventSchema }),
  z.object({ kind: z.literal('error'), message: z.string() }),
]);
export type LlmLogStreamEvent = z.infer<typeof llmLogStreamEvent>;

export const llmLogStreamRoute = defineRouteDef({
  method: 'GET',
  path: '/api/llm-log/stream',
  audience: 'user',
  events: llmLogStreamEvent,
});
